import { z } from 'zod';
import { Pegasus } from '../../schema/pegasus.js';
import { variant } from '../../schema/storeProduct.js';
const option = z.object({ name: z.string(), position: z.number() });
export const productOptions = z.array(option);
const product = z.object({
    idFromPlatform: z.string(),
    name: z.string(),
    imageUrl: z.string().nullable(),
    hasOnlyDefaultVariant: z.boolean(),
    createdOn: z.string().optional(),
});
export const productWithOptions = product.extend({
    options: z.array(option.merge(z.object({ values: z.array(z.string()) }))),
    variants: z.array(variant),
});
const productFilter = z.object({
    name: z.string(),
    values: z.array(z.string()),
    type: z.literal('option'),
});
// * variant exchange
export const productVariantExchangeResponse = z.object({
    advancedExchangeMethod: Pegasus.advancedExchangeMethodUnion,
    isFilterAndSearchEnabled: z.boolean(),
    filters: z.array(productFilter).optional(),
    products: z.array(productWithOptions),
});
export const collection = z.object({
    id: z.number(),
    title: z.string(),
    description: z.string().optional(),
});
//# sourceMappingURL=variantExchange.js.map